import trial from './trial'
import features from './features'
import payment from './payment'
import somosEducacao from './somosEducacao'
import modular from './modular'
import paranaNotice from './parana-notice'
import selectEntity from './select-entity'
import adminMobile from './admin-mobile'
import storyTree from './storyTree'
import type {
  GetLocationToRedirectProps,
  LocationType,
  RedirectsPrevLocationState
} from './types'

function getLocationToRedirect({
  user,
  routePath,
  prevState,
  isSuperAutorEligible
}: GetLocationToRedirectProps): LocationType {
  const homeRedirect = modular.getRedirectLocation(
    user,
    routePath,
    isSuperAutorEligible
  )
  if (homeRedirect.pathname?.length > 0) {
    return homeRedirect
  }

  const pendingRedirects = [
    payment.getRedirectLocation(user, routePath),
    selectEntity.getRedirectLocation(user, routePath),
    adminMobile.getRedirectLocation(user, routePath),
    features.getRedirectLocation(user, routePath),
    trial.getRedirectLocation(user, routePath),
    somosEducacao.getRedirectLocation(user, routePath),
    paranaNotice.getRedirectLocation(user, routePath),
    storyTree.getRedirectLocation(user, routePath)
  ].filter(redirect => redirect.pathname?.length > 0)

  if (pendingRedirects[0] && !prevState?.wasRedirected) {
    return {
      ...pendingRedirects[0],
      state: {
        wasRedirected: true,
        ...(typeof pendingRedirects[0].state === 'object'
          ? pendingRedirects[0].state
          : {})
      }
    }
  }

  // no redirects
  return {
    pathname: ''
  }
}

export default {
  getLocationToRedirect
}

export type {
  GetLocationToRedirectProps,
  LocationType,
  RedirectsPrevLocationState
}
